var map = {
	"./academic_painting_fake.webp": 4601,
	"./amazing_painting_fake.webp": 4993,
	"./ancient_statue_fake.webp": 7458,
	"./basic_painting_fake.webp": 5014,
	"./beautiful_statue_fake.webp": 7893,
	"./detailed_painting_fake.webp": 779,
	"./famous_painting_fake.webp": 6189,
	"./gallant_statue_fake.webp": 1112,
	"./graceful_painting_fake.webp": 9177,
	"./informative_statue_fake.webp": 5816,
	"./jolly_painting_fake.webp": 8729,
	"./motherly_statue_fake.webp": 9934,
	"./moving_painting_fake.webp": 7608,
	"./mystic_statue_fake.webp": 4322,
	"./quaint_painting_fake.webp": 4413,
	"./robust_statue_fake.webp": 2653,
	"./rock_head_statue_fake.webp": 4578,
	"./scary_painting_fake.webp": 4975,
	"./scenic_painting_fake.webp": 457,
	"./serene_painting_fake.webp": 8440,
	"./solemn_painting_fake.webp": 1591,
	"./tremendous_statue_fake.webp": 356,
	"./valiant_statue_fake.webp": 7907,
	"./warrior_statue_fake.webp": 6261,
	"./wild_painting_left_half_fake.webp": 4124,
	"./wild_painting_right_half_fake.webp": 9358,
	"./wistful_painting_fake.webp": 4829
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6082;